module.exports = {
  schema: {
    name: '供應商資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '供應商編碼',
        unique: true,
      },
      shortName: {
        type: 'String',
        name: '簡稱',
      },
      email: {
        type: 'String',
        name: 'email',
      },
      fax: {
        type: 'String',
        name: '傳真',
      },
      phone: {
        type: 'String',
        name: '電話',
      },
      name: {
        type: 'String',
        name: '名稱',
      },
      invoiceTitle: {
        type: 'String',
        name: '發票抬頭',
      },
      taxId: {
        type: 'String',
        name: '統編',
      },
      zip: {
        type: 'String',
        name: '郵遞區號',
      },
      address: {
        type: 'String',
        name: '公司地址',
      },
      owner: {
        type: 'String',
        name: '負責人',
      },
      contact: {
        type: 'String',
        name: '聯絡人',
      },
      type: {
        type: 'String',
        name: '類別',
        options: ['連鎖', '一般', '現銷'],
      },
      groupRef: {
        type: 'ObjectId',
        reference: 'customerGroups',
        refKeys: ['key'],
        name: '群組',
      },
      salesRegionRef: {
        type: 'ObjectId',
        reference: 'salesRegions',
        refKeys: ['key', 'name'],
        name: '區域名稱',
      },
      deliveryNote: {
        type: 'String',
        name: '交貨備註',
      },
      salesPersonRef: {
        type: 'ObjectId',
        reference: 'staffers',
        refKeys: ['name'],
        name: '業務代表',
      },
      printPrice: {
        type: 'Boolean',
        name: '列印售價',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'shortName', width: 100 },
        { key: 'type', width: 60 },
        { key: 'groupRef', width: 65 },
        { key: 'contact', width: 90 },
        { key: 'phone', width: 130 },
        { key: 'fax', width: 130 },
        { key: 'address', width: 200 },
        { key: 'salesPersonRef', width: 85 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '系統資料',
          rows: [
            [{ key: 'key' }, {}],
          ],
        }, {
          name: '基本資料',
          rows: [
            [{ key: 'shortName' }, { key: 'email' }],
            [{ key: 'fax' }, { key: 'phone' }],
          ],
        }, {
          name: '發票資料',
          rows: [
            [{ key: 'name' }, {}],
            [{ key: 'invoiceTitle' }, { key: 'taxId' }],
            [{ key: 'zip' }, { key: 'address' }],
            [{ key: 'owner' }, { key: 'contact' }],
          ],
        }, {
          name: '業務管理資料',
          rows: [
            [{ key: 'type' }, { key: 'groupRef' }],
            [{ key: 'salesRegionRef' }, { key: 'deliveryNote' }],
            [{ key: 'salesPersonRef' }, { key: 'printPrice' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/suppliers.js